<div class="container-slide pointer {{direction}}" (click)="setSelect()">
    <div class="circle" ></div>
    <span class="board-select" [ngClass]="{'animation-on':isActive}">{{select}}</span>
</div>